const initProductDetailsSwiper = function(){
    let productDetails = document.querySelectorAll('.product-details__container');
  
    productDetails.forEach((productDetailsSection) => {
      let textArray = [];
      productDetailsSection.querySelectorAll('.swiper-slide').forEach((slide) => {
        textArray.push(`${slide.getAttribute('data-nav-text')}`)
    });
      let selector = `#${productDetailsSection.parentElement.id} .product-details__slides`;
      let params = {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
        freeMode: false,
        loop: false,
        autoplay: false,
        scrollbar: {
          el: ".product-details__container .swiper-scrollbar",
          horizontalClass: 'swiper-scrollbar-horizontal',
          hide: false,
        },
        pagination: {
          el: ".product-details__container .swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + `${textArray[index]}` + '</span>';
            },
        },
        on: {
            init: function () {
                productDetailsSection.closest('section').querySelector('.product-details__nav').style.opacity = '0'
            }
        }
      };
  
      var productDetailsSwiper = new Swiper(selector, params);
    })
  }
    
window.addEventListener('load', function(){
    initProductDetailsSwiper();
});
